import type { DayKey, DayScheduleInterface } from '@nebalkon-workspace/content-api';

export const WORK_SCHEDULE_DAY_KEYS: Record<DayKey, string> = {
  monday: 'CLIENT.CABINET.HELP.WORK_SCHEDULE.DAYS.monday',
  tuesday: 'CLIENT.CABINET.HELP.WORK_SCHEDULE.DAYS.tuesday',
  wednesday: 'CLIENT.CABINET.HELP.WORK_SCHEDULE.DAYS.wednesday',
  thursday: 'CLIENT.CABINET.HELP.WORK_SCHEDULE.DAYS.thursday',
  friday: 'CLIENT.CABINET.HELP.WORK_SCHEDULE.DAYS.friday',
  saturday: 'CLIENT.CABINET.HELP.WORK_SCHEDULE.DAYS.saturday',
  sunday: 'CLIENT.CABINET.HELP.WORK_SCHEDULE.DAYS.sunday',
};

export const WORK_SCHEDULE_DAY_OFF_KEY =
  'CLIENT.CABINET.HELP.WORK_SCHEDULE.DAY_OFF';

export type WorkScheduleTranslateFn = (
  key: string,
  params?: Record<string, string>,
) => string;

const DEFAULT_DAY_LABELS: Record<DayKey, string> = {
  monday: 'Пн',
  tuesday: 'Вт',
  wednesday: 'Ср',
  thursday: 'Чт',
  friday: 'Пт',
  saturday: 'Сб',
  sunday: 'Вс',
};

export function formatWorkSchedule(
  schedule: Record<DayKey, DayScheduleInterface> | undefined,
  translate?: WorkScheduleTranslateFn,
): string {
  if (!schedule) return '';

  const daysMap: Record<DayKey, string> = translate
    ? (Object.fromEntries(
        (Object.keys(WORK_SCHEDULE_DAY_KEYS) as DayKey[]).map((dayKey) => [
          dayKey,
          translate(WORK_SCHEDULE_DAY_KEYS[dayKey]),
        ]),
      ) as Record<DayKey, string>)
    : DEFAULT_DAY_LABELS;

  const daysOrder: DayKey[] = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];

  const groups: Array<{
    days: string[];
    from: string;
    to: string;
    isWorking: boolean;
  }> = [];

  daysOrder.forEach((dayKey) => {
    const daySchedule = schedule[dayKey];
    if (!daySchedule) return;
    const lastGroup = groups[groups.length - 1];

    if (
      lastGroup &&
      lastGroup.from === daySchedule.from &&
      lastGroup.to === daySchedule.to &&
      lastGroup.isWorking === daySchedule.isWorking
    ) {
      lastGroup.days.push(daysMap[dayKey]);
    } else {
      groups.push({
        days: [daysMap[dayKey]],
        from: daySchedule.from,
        to: daySchedule.to,
        isWorking: daySchedule.isWorking,
      });
    }
  });

  const formattedGroups = groups.map((group) => {
    if (!group.isWorking) {
      const daysRange = group.days.join('-');
      return translate
        ? translate(WORK_SCHEDULE_DAY_OFF_KEY, { days: daysRange })
        : `${daysRange} — выходной`;
    }

    const daysRange =
      group.days.length > 1
        ? `${group.days[0]}-${group.days[group.days.length - 1]}`
        : group.days[0];

    return `${daysRange} ${group.from}-${group.to}`;
  });

  return formattedGroups.join('; ');
}
